export default __webpack_public_path__ + "static/logo-f01fbd5908cc83f52ffb1cbe9f40e487.svg";